import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { CostEstimate, CostTariffs } from '../interfaces/costs.interface';

export const costsApi = {
  async tariffs(direction?: ShippingDirection): Promise<CostTariffs> {
    const params: Record<string, string> = {};
    if (direction) params.direction = direction;
    const response = await http.get('/costs/tariffs', { params });
    return response.data?.data as CostTariffs;
  },

  async estimate(companyId?: number, direction?: ShippingDirection): Promise<CostEstimate> {
    const params: Record<string, string | number> = {};
    if (typeof companyId === 'number') params.companyId = companyId;
    if (direction) params.direction = direction;
    const response = await http.get('/costs/estimate', { params });
    return response.data?.data as CostEstimate;
  },
};
